import { render, staticRenderFns } from "./RequestViewLogs.vue?vue&type=template&id=59e142f8"
import script from "./RequestViewLogs.vue?vue&type=script&lang=js"
export * from "./RequestViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports